import '../styles/PageGlobal.css';
import './AchatPage.css';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import ReferenceButton from '../components/ReferenceButton';
import { AchatService } from '../services/AchatService.js';
import { ApprovisionnementService } from '../services/ApprovisionnementService.js';
import { WorkFlowService } from '../services/WorkFlowService.js';
import AchatQuotaModal from "../components/AchatQuotaModal";
import ProduitsPicker from '../components/ProduitsPicker.js';
import DevisAdresseLivPicker from '../components/DevisAdresseLivPicker';
import DevisClientPicker from '../components/DevisClientPicker';
import { useLocation } from 'react-router-dom';
import { ProductService } from '../services/ProductService.js';
import { FournisseurService } from '../services/FournisseurService.js'; 



export default function AchatPage() {
  const location = useLocation();

  const productService = useMemo(() => new ProductService(), []);
  const fournisseurService = useMemo(() => new FournisseurService(), []);

  const [fournisseurs, setFournisseurs] = useState([]);



  const TABS = [
    { key: 'achatafaire', label: 'Achats à faire' },
    { key: 'toutes', label: 'Toutes les achats (BCC)' },
    { key: 'approvisionnement', label: 'Achats en direct' },
    { key: 'aacheterref', label: 'A acheter par Référence' },
    { key: 'cloturees', label: 'Achat lines cloturees' },
  ];

  const [activeTab, setActiveTab] = useState(location.state?.openTab || 'achatafaire'); 

  // VARIABLES SÉPARÉES (Données brutes du backend)
  const [approLignes, setApproLignes] = useState([]);
  const [approLoading, setApproLoading] = useState(true);
  const [approError, setApproError] = useState(null);

  const [toutesLignes, setToutesLignes] = useState([]);
  const [toutesLoading, setToutesLoading] = useState(true);
  const [toutesError, setToutesError] = useState(null);

  const [aacheterrefLignes, setAacheterrefLignes] = useState([]);
  const [aacheterrefLoading, setAacheterrefLoading] = useState(true);
  const [aacheterrefError, setAacheterrefError] = useState(null);
  const [aacheterrefDecoupageLines, setAacheterrefDecoupageLines] = useState([]);
  const [quotaChannel, setQuotaChannel] = useState('EMAIL');

  const [clotureesLignes, setClotureesLignes] = useState([]);
  const [clotureesLoading, setClotureesLoading] = useState(true);
  const [clotureesError, setClotureesError] = useState(null);

  // MODAL QUOTA
  const [quotaModalOpen, setQuotaModalOpen] = useState(false);
  const [selectedLine, setSelectedLine] = useState(null);
  
  // 🟢 NOUVEAU : Gestion de la sélection multiple pour "Achats à faire"
  const [selectedLineIds, setSelectedLineIds] = useState(new Set());
  const [massQuotaLines, setMassQuotaLines] = useState([]);

  // MODAL CRÉATION APPRO
  const [showApproModal, setShowApproModal] = useState(false);
  const [showApproClientPicker, setShowApproClientPicker] = useState(false);
  const [showApproAdressePicker, setShowApproAdressePicker] = useState(false);
  const [showApproProduitPicker, setShowApproProduitPicker] = useState(false);
  const [approClientId, setApproClientId] = useState(null);
  const [approClientNom, setApproClientNom] = useState('');
  const [approAdresseLivId, setApproAdresseLivId] = useState(null);
  const [approNewLines, setApproNewLines] = useState([]);

  const achatService = useMemo(() => new AchatService(), []);
  const approvisionnementService = useMemo(() => new ApprovisionnementService(), []);
  const workflowService = useMemo(() => new WorkFlowService(), []);

  // ── FETCH DIRECTS ──
  const fetchAppro = useCallback(async () => {
    setApproLoading(true); setApproError(null);
    try {
      const data = (await approvisionnementService.fetchAllLines()) || [];

      // 1. unique product ids
      const productIds = [...new Set(data.map(l => l.productId).filter(Boolean))];

      // 2. fetch each product once, in parallel; a failed product must not break the table
      const results = await Promise.all(
        productIds.map(async (id) => {
          try {
            return [id, await productService.getProductById(id)];
          } catch (e) {
            console.warn(`Produit ${id} introuvable`, e);
            return [id, null];
          }
        })
      );
      const productsById = new Map(results);

      // 3. merge
      setApproLignes(data.map(line => {
        const p = productsById.get(line.productId);
        return {
          id: line.id,
          productId: line.productId,
          reference: p?.refInterne || p?.designation || 'N/A',
          refFabricant: p?.refFabricant || p?.ean || 'N/A',
          quantity: line.quantity || 0,
          unitPrice: line.unitPrice || 0,
          status: line.status || 'DRAFT',
          source: 'APPRO'
        };
      }));
    } catch (err) {
      setApproError(err.message);
    } finally {
      setApproLoading(false);
    }
  }, [approvisionnementService, productService]);

  const fetchFournisseurs = useCallback(async () => {
  try {
    const data = (await fournisseurService.getAllFournisseurs()) || [];  
    setFournisseurs(data.map(f => ({
      id: f.id,
      nom: f.nom || f.raisonSociale || f.societe1 || `Fournisseur #${f.id}`
    })));
  } catch (err) {
    console.error("Erreur chargement fournisseurs :", err);
  }
}, [fournisseurService]);

  const fetchToutes = useCallback(async () => {
    setToutesLoading(true); setToutesError(null);
    try {
      const data = await achatService.fetchToutesCommandes();
      setToutesLignes((data || []).map(line => ({
        ...line,
        id: line.id, // 🟢 S'assurer que l'ID est bien présent
        source: 'ACHAT'
      })));
    } catch (err) { setToutesError(err.message); } 
    finally { setToutesLoading(false); }
  }, [achatService]);

  const fetchAacheterref = useCallback(async () => {
    setAacheterrefLoading(true); setAacheterrefError(null);
    try {
      const data = await achatService.fetchAAcheter();
      setAacheterrefLignes(data || []);
    } catch (err) { setAacheterrefError(err.message); } 
    finally { setAacheterrefLoading(false); }
  }, [achatService]);

  const fetchCloturees = useCallback(async () => {
    setClotureesLoading(true); setClotureesError(null);
    try {
      const data = await achatService.fetchAchatLineCloturees();
      setClotureesLignes(data || []);
    } catch (err) { setClotureesError(err.message); } 
    finally { setClotureesLoading(false); }
  }, [achatService]);

  useEffect(() => {
    fetchAppro();
    fetchToutes();
    fetchAacheterref();
    fetchCloturees();
     fetchFournisseurs();
  }, [fetchAppro, fetchToutes, fetchAacheterref, fetchCloturees,fetchFournisseurs]);

  // 🟢 Fusion des données pour "Achats à faire"
  const achatsAFaireLignes = useMemo(() => {
    const combined = [...approLignes, ...toutesLignes];
    return combined.filter(ligne => ligne.status !== 'CLOSED');
  }, [approLignes, toutesLignes]);

  const isAchatsAFaireLoading = approLoading || toutesLoading;
  const achatsAFaireError = approError || toutesError;

  const handleTabClick = (tab) => {
    setActiveTab(tab.key);
  };

  // ── HANDLERS SÉLECTION MULTIPLE (Avec DEBUG) ──
  const toggleMassSelection = (ligne) => {
    console.log("🟢 [DEBUG] Checkbox cliqué pour la ligne:", ligne);
    const newSet = new Set(selectedLineIds);
    if (newSet.has(ligne.id)) {
      newSet.delete(ligne.id);
    } else {
      newSet.add(ligne.id);
    }
    console.log("🟢 [DEBUG] Nouveaux IDs sélectionnés:", Array.from(newSet));
    setSelectedLineIds(newSet);
    
    const selected = achatsAFaireLignes.filter(l => newSet.has(l.id));
    console.log("🟢 [DEBUG] Lignes préparées pour la modale:", selected);
    setMassQuotaLines(selected);
  };

  const openMassQuotaModal = () => {
    console.log("🟢 [DEBUG] Bouton 'Demande de Quota en Masse' cliqué !");
    console.log("🟢 [DEBUG] Contenu de massQuotaLines avant ouverture:", massQuotaLines);
    setQuotaModalOpen(true);
  };

  const clearMassSelection = () => {
    console.log("🟢 [DEBUG] Sélection annulée");
    setSelectedLineIds(new Set());
    setMassQuotaLines([]);
  };

  // ── HANDLERS DÉCOUPAGE ──
  const handleAacheterrefDecoupage = (ligne) => {
    setAacheterrefDecoupageLines(prev => [...prev, {
      ...ligne,
      id: `${ligne.id}-S${Math.random().toString(36).substring(2, 6)}`,
      parentAchatLineId: ligne.id,
      isSplit: true,
      quantity: Math.floor((ligne.quantity || 0) / 2)
    }]);
  };

  const handleAacheterrefValidateDecoupage = () => {
    if (aacheterrefDecoupageLines.length === 0) return;
    console.log("SAVE DECOUPAGE TO BACKEND:", aacheterrefDecoupageLines);
    setAacheterrefDecoupageLines([]);
    alert("Découpage validé (simulation)");
  };

  const displayedAacheterrefLignes = useMemo(() => {
    const result = [];
    aacheterrefLignes.forEach((ligne) => {
      result.push(ligne);
      result.push(...aacheterrefDecoupageLines.filter((s) => s.parentAchatLineId === ligne.id));
    });
    return result;
  }, [aacheterrefLignes, aacheterrefDecoupageLines]);

  // ── HANDLER CLÔTURE / TRANSFORMATION ──
  const handleClot = async (ligne) => {
    if (!window.confirm('Confirmer l\'action de clôture ?')) return;
    try {
      if (ligne.source === 'APPRO') {
        await approvisionnementService.closeLine(ligne.id);
        alert("Ligne d'approvisionnement clôturée avec succès !");
        fetchAppro();
      } else if (ligne.source === 'ACHAT') {
        await achatService.postClot(ligne.id);
        await workflowService.transformAchatLineToBcf(ligne.id);
        alert("Ligne d'achat clôturée et transformée en BCF avec succès.");
        fetchToutes();
      } else {
        alert("Action non prise en charge.");
      }
    } catch (err) {
      console.error("Erreur lors de l'action :", err);
      alert("Erreur : " + err.message);
    }
  };

  // ── HANDLERS MODAL APPRO ──
  const handleApproClientSelect = (client) => {
    setApproClientId(client.id);
    setApproClientNom(client.nom || client.societe1 || 'Client sélectionné');
    setShowApproClientPicker(false);
  };

  const handleApproAdresseSelect = (adresse) => {
    setApproAdresseLivId(adresse.id);
    setShowApproAdressePicker(false);
  };

  const handleApproProductSelect = (products) => {
    const newLines = products.map((p, index) => ({
      id: Date.now() + index,
      productId: p.id,
      reference: p.refInterne || 'N/A',
      refFabricant: p.refFabricant || 'N/A',
      quantity: 1,
      unitPrice: 0
    }));
    setApproNewLines(prev => [...prev, ...newLines]);
    setShowApproProduitPicker(false);
  };

  const handleRemoveApproLine = (id) => {
    setApproNewLines(approNewLines.filter(l => l.id !== id));
  };

  const handleApproLineChange = (id, field, value) => {
    setApproNewLines(approNewLines.map(l => l.id === id ? { ...l, [field]: value } : l));
  };

  const handleCreateApprovisionnement = async () => {
    if (!approClientId) return alert("Veuillez sélectionner un client.");
    if (approNewLines.length === 0) return alert("Veuillez ajouter au moins un produit.");
    try {
      const payload = {
        clientId: approClientId,
        adresseLivraisonId: approAdresseLivId,
        status: "DRAFT",
        notes: "Créé depuis l'interface Achat",
        lines: approNewLines.map(l => ({
          productId: l.productId,
          reference: l.reference,
          refFabricant: l.refFabricant,
          quantity: Number(l.quantity),
          unitPrice: Number(l.unitPrice)
        }))
      };
      await approvisionnementService.createApprovisionnement(payload);
      alert("Approvisionnement créé avec succès !");
      setShowApproModal(false);
      setApproClientId(null);
      setApproClientNom('');
      setApproAdresseLivId(null);
      setApproNewLines([]);
      fetchAppro();
    } catch (err) {
      alert("Erreur création : " + err.message);
    }
  };

  return (
    <div className="containerMain achat-container">
      <h1 className="achat-title">Achat</h1>
      <p>Ceci est un contenu protégé</p>

      <div className="achat-tabs">
        {TABS.map((tab) => (
          <ReferenceButton
            key={tab.key}
            onClick={() => handleTabClick(tab)}
            className={`achat-tab-btn${activeTab === tab.key ? ' active' : ''}`}
          >
            {tab.label}
          </ReferenceButton>
        ))}
      </div>

      {/* ══════════════════════════════════════════════════════════ */}
      {/* 🟢 TABLEAU 0 : ACHATS À FAIRE (AVEC SÉLECTION LIGNE)      */}
      {/* ══════════════════════════════════════════════════════════ */}
      {activeTab === 'achatafaire' && (
        <div>
          {isAchatsAFaireLoading ? <div>Chargement des données…</div> : achatsAFaireError ? (
            <div className="devis-status devis-status-error">{achatsAFaireError}</div>
          ) : (
            <div className="achat-table-wrapper">
              
              {/* 🟢 BARRE D'ACTION EN MASSE */}
              {selectedLineIds.size > 0 && (
                <div style={{ 
                  marginBottom: '15px', 
                  padding: '12px', 
                  backgroundColor: '#e3f2fd', 
                  borderRadius: '6px', 
                  display: 'flex', 
                  gap: '15px', 
                  alignItems: 'center',
                  border: '1px solid #90caf9'
                }}>
                  <span style={{ fontWeight: 'bold', color: '#1565c0' }}>
                    {selectedLineIds.size} ligne(s) sélectionnée(s)
                  </span>
                  <button className="achat-btn achat-btn-green" onClick={openMassQuotaModal}>
                    📩 Demande de Quota en Masse Email
                  </button>
                  <button className="achat-btn achat-btn-grey" onClick={clearMassSelection}>
                    Annuler la sélection
                  </button>
                </div>
              )}

              <table className="achat-table">
                <thead>
                  <tr>
                    <th style={{ width: '40px' }}>Sel.</th>
                    <th>Source</th>
                    <th>N</th>
                    <th>Référence</th>
                    <th>Ref. Fabricant</th>
                    <th>Quantité</th>
                    <th>Statut</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {achatsAFaireLignes.length === 0 ? (
                    <tr><td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>Aucun achat à faire pour le moment.</td></tr>
                  ) : (
                    achatsAFaireLignes.map((ligne, index) => (
                      <tr key={`${ligne.source}-${ligne.id}`} style={{ backgroundColor: selectedLineIds.has(ligne.id) ? '#f1f8e9' : 'transparent' }}>
                        <td>
                          <input 
                            type="checkbox" 
                            checked={selectedLineIds.has(ligne.id)}
                            onChange={() => toggleMassSelection(ligne)}
                          />
                        </td>
                        <td>
                          <span style={{ 
                            padding: '4px 8px', 
                            borderRadius: '4px', 
                            fontSize: '12px', 
                            fontWeight: 'bold',
                            backgroundColor: ligne.source === 'APPRO' ? '#e3f2fd' : '#f3e5f5',
                            color: ligne.source === 'APPRO' ? '#1565c0' : '#6a1b9a'
                          }}>
                            {ligne.source === 'APPRO' ? '📦 Direct' : '🛒 Achat'}
                          </span>
                        </td>
                        <td>{index + 1}</td>
                        <td className="achat-ref"><div className="achat-ref-inner">{ligne.reference || 'N/A'}</div></td>
                        <td>{ligne.refFabricant || 'N/A'}</td>
                        <td>{ligne.quantity || 0}</td>
                        <td>
                          <span style={{ color: ligne.status === 'CLOSED' ? 'red' : 'green', fontWeight: 'bold' }}>
                            {ligne.status}
                          </span>
                        </td>
                        <td>
                          <button className="achat-btn achat-btn-blue" onClick={() => handleClot(ligne)}>
                            Clôturer
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════ */}
      {/* TABLEAU 1 : APPROVISIONNEMENT (INCHANGÉ)                  */}
      {/* ══════════════════════════════════════════════════════════ */}
      {activeTab === 'approvisionnement' && (
        <div>
          <div style={{ marginBottom: "10px" }}>
            <button className="boncomclient-btn boncomclient-btn-blue" onClick={() => setShowApproModal(true)}>
              ➕ Nouvel achat en direct
            </button>
          </div>
          {approLoading ? <div>Chargement…</div> : approError ? <div className="devis-status devis-status-error">{approError}</div> : (
            <div className="achat-table-wrapper">
              <table className="achat-table">
                <thead>
                  <tr>
                    <th>N</th><th>Réf. Désignation</th><th>EAN</th><th>Quantité</th>
                    <th>Prix Unitaire</th><th>Statut</th>
                    <th>WhatsApp Quota</th><th>Email Quota</th><th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {approLignes.map((ligne, index) => (
                    <tr key={ligne.id}>
                      <td>{index + 1}</td>
                      <td>{ligne.reference}</td>
                      <td>{ligne.refFabricant}</td>
                      <td>{ligne.quantity}</td>
                      <td>{ligne.unitPrice} €</td>
                      <td>
                        <span style={{ color: ligne.status === 'CLOSED' ? 'red' : 'green', fontWeight: 'bold' }}>
                          {ligne.status}
                        </span>
                      </td>
                      <td><button 
                            className="achat-btn achat-btn-green" 
                            onClick={() => { 
                              setSelectedLine(ligne); 
                              setQuotaChannel('WHATSAPP'); 
                              setQuotaModalOpen(true); 
                            }}
                          >
                            WhatsApp
                          </button></td>
                                                <td><button 
                            className="achat-btn achat-btn-green" 
                            onClick={() => { 
                              setSelectedLine(ligne); 
                              setQuotaChannel('EMAIL'); 
                              setQuotaModalOpen(true); 
                            }}
                          >
                            Email
                          </button></td>
                      <td>
                        <button className="achat-btn achat-btn-blue" onClick={() => handleClot(ligne)} disabled={ligne.status === 'CLOSED'}>
                          Clôturer
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════ */}
      {/* TABLEAU 2 : TOUTE LES ACHATS (INCHANGÉ)                   */}
      {/* ══════════════════════════════════════════════════════════ */}
      {activeTab === 'toutes' && (
        <div>
          {toutesLoading ? <div>Chargement…</div> : toutesError ? <div className="devis-status devis-status-error">{toutesError}</div> : (
            <div className="achat-table-wrapper">
              <table className="achat-table">
                <thead>
                  <tr>
                    <th>N</th><th>Référence</th><th>Ref. Fabricant</th><th>Quantité</th><th>BCC de provenance</th>
                    <th>Statut</th><th>Parent ID DECOUPAGE</th><th>Created</th><th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {toutesLignes.length === 0 ? (
                    <tr><td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>Aucune donnée.</td></tr>
                  ) : (
                    toutesLignes.map((ligne, index) => (
                      <tr key={ligne.id}>
                        <td>{index + 1}</td>
                        <td className="achat-ref"><div className="achat-ref-inner">{ligne.reference || 'N/A'}</div></td>
                        <td>{ligne.refFabricant || 'N/A'}</td>
                        <td>{ligne.quantity || 0}</td>
                        <td>{ligne.bccIds && ligne.bccIds.length > 0 ? ligne.bccIds.join(', ') : 'N/A'}</td>
                        <td>{ligne.status || 'N/A'}</td>
                        <td>{ligne.parentAchatLineId || 'N/A'}</td>
                        <td>{ligne.createdAt || 'N/A'}</td>
                        <td>
                          <button className="achat-btn achat-btn-blue" onClick={() => handleClot(ligne)}>
                            Clôturer
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════ */}
      {/* TABLEAU 3 : A ACHETER PAR RÉFÉRENCE (INCHANGÉ)            */}
      {/* ══════════════════════════════════════════════════════════ */}
      {activeTab === 'aacheterref' && (
        <div>
          <div style={{ marginBottom: "10px", display: 'flex', gap: '10px' }}>
            <button className="boncomclient-btn boncomclient-btn-blue" onClick={handleAacheterrefValidateDecoupage} disabled={aacheterrefDecoupageLines.length === 0}>
              Valider découpage
            </button>
            <button className="boncomclient-btn boncomclient-btn-grey" onClick={() => setAacheterrefDecoupageLines([])} disabled={aacheterrefDecoupageLines.length === 0}>
              Reset Découpage
            </button>
          </div>
          {aacheterrefLoading ? <div>Chargement…</div> : aacheterrefError ? <div className="devis-status devis-status-error">{aacheterrefError}</div> : (
            <div className="achat-table-wrapper">
              <table className="achat-table">
                <thead>
                  <tr>
                    <th>N</th><th>Référence</th><th>Ref. Fabricant</th><th>Quantité</th>
                    <th>Statut</th><th>WhatsApp</th><th>Email</th><th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedAacheterrefLignes.length === 0 ? (
                    <tr><td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>Aucune donnée.</td></tr>
                  ) : (
                    displayedAacheterrefLignes.map((ligne, index) => (
                      <tr key={ligne.id} className={ligne.isSplit ? "split-row" : ""}>
                        <td>{index + 1}</td>
                        <td className="achat-ref">
                          <div className="achat-ref-inner">
                            {!ligne.isSplit && (
                              <button className="achat-btn achat-btn-split" onClick={() => handleAacheterrefDecoupage(ligne)} style={{ marginRight: "6px" }}>
                                Découper
                              </button>
                            )}
                            {ligne.reference || 'N/A'} {ligne.isSplit && <span style={{color: 'blue', fontSize: '0.8em'}}>(Split)</span>}
                          </div>
                        </td>
                        <td>{ligne.refFabricant || 'N/A'}</td>
                        <td>
                          <input 
                            type="number" 
                            value={ligne.quantity || 0} 
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              setAacheterrefDecoupageLines(prev => prev.map(l => l.id === ligne.id ? { ...l, quantity: value } : l));
                            }} 
                            style={{ width: "60px" }} 
                          />
                        </td>
                        <td>{ligne.status || 'N/A'}</td>
                        <td><button 
                              className="achat-btn achat-btn-green" 
                              onClick={() => { 
                                setSelectedLine(ligne); 
                                setQuotaChannel('WHATSAPP'); // 🟢 On définit le canal
                                setQuotaModalOpen(true); 
                              }}
                            >
                              WhatsApp
                            </button></td>
                                                    <td><button 
                              className="achat-btn achat-btn-green" 
                              onClick={() => { 
                                setSelectedLine(ligne); 
                                setQuotaChannel('EMAIL'); // 🟢 On définit le canal
                                setQuotaModalOpen(true); 
                              }}
                            >
                              Email
                            </button></td>
                        <td><button className="achat-btn achat-btn-blue" onClick={() => handleClot(ligne)}>Clôturer</button></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════ */}
      {/* TABLEAU 4 : ACHAT LINES CLOTURÉES (INCHANGÉ)              */}
      {/* ══════════════════════════════════════════════════════════ */}
      {activeTab === 'cloturees' && (
        <div>
          {clotureesLoading ? <div>Chargement…</div> : clotureesError ? <div className="devis-status devis-status-error">{clotureesError}</div> : (
            <div className="achat-table-wrapper">
              <table className="achat-table">
                <thead>
                  <tr>
                    <th>N</th><th>Référence</th><th>Ref. Fabricant</th><th>Quantité</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {clotureesLignes.length === 0 ? (
                    <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Aucune donnée.</td></tr>
                  ) : (
                    clotureesLignes.map((ligne, index) => (
                      <tr key={ligne.id}>
                        <td>{index + 1}</td>
                        <td className="achat-ref"><div className="achat-ref-inner">{ligne.reference || 'N/A'}</div></td>
                        <td>{ligne.refFabricant || 'N/A'}</td>
                        <td>{ligne.quantity || 0}</td>
                        <td>{ligne.status || 'N/A'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════ */}
      {/* MODAL CRÉATION APPROVISIONNEMENT (INCHANGÉ)               */}
      {/* ══════════════════════════════════════════════════════════ */}
      {showApproModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', width: '800px', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <h2 style={{ marginTop: 0 }}>Nouvel achat en direct</h2>
            
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
              <ReferenceButton onClick={() => setShowApproClientPicker(true)}>
                {approClientNom ? `Client: ${approClientNom}` : '+ Sélectionner un client'}
              </ReferenceButton>
              <ReferenceButton onClick={() => setShowApproAdressePicker(true)}>
                {approAdresseLivId ? `Adresse ID: ${approAdresseLivId}` : '+ Adresse de livraison'}
              </ReferenceButton>
              <ReferenceButton onClick={() => setShowApproProduitPicker(true)}>
                + Ajouter des produits
              </ReferenceButton>
            </div>

            {showApproClientPicker && <DevisClientPicker onClose={() => setShowApproClientPicker(false)} onSelect={handleApproClientSelect} />}
            {showApproAdressePicker && <DevisAdresseLivPicker clientId={approClientId} onClose={() => setShowApproAdressePicker(false)} onSelect={handleApproAdresseSelect} />}
            {showApproProduitPicker && <ProduitsPicker onClose={() => setShowApproProduitPicker(false)} onSelect={handleApproProductSelect} />}

            <div className="devis-table-wrapper" style={{ marginTop: '20px' }}>
              <table className="devis-table">
                <thead>
                  <tr>
                    <th>Référence</th><th>Ref. Fabricant</th><th>Product ID</th>
                    <th>Quantité</th><th>Prix Unitaire</th><th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {approNewLines.length === 0 ? (
                    <tr><td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>Aucun produit ajouté</td></tr>
                  ) : (
                    approNewLines.map((line) => (
                      <tr key={line.id}>
                        <td><input type="text" value={line.reference} onChange={(e) => handleApproLineChange(line.id, 'reference', e.target.value)} style={{ width: '100px', padding: '4px' }} /></td>
                        <td><input type="text" value={line.refFabricant} onChange={(e) => handleApproLineChange(line.id, 'refFabricant', e.target.value)} style={{ width: '120px', padding: '4px' }} /></td>
                        <td><input type="number" value={line.productId} onChange={(e) => handleApproLineChange(line.id, 'productId', Number(e.target.value))} style={{ width: '80px', padding: '4px' }} /></td>
                        <td><input type="number" min="1" value={line.quantity} onChange={(e) => handleApproLineChange(line.id, 'quantity', Number(e.target.value))} style={{ width: '60px', padding: '4px' }} /></td>
                        <td><input type="number" min="0" step="0.01" value={line.unitPrice} onChange={(e) => handleApproLineChange(line.id, 'unitPrice', Number(e.target.value))} style={{ width: '80px', padding: '4px' }} /></td>
                        <td><button className="devis-btn devis-btn-red" onClick={() => handleRemoveApproLine(line.id)}>Supprimer</button></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div style={{ display: 'flex', gap: '10px', marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
              <button className="boncomclient-btn boncomclient-btn-blue" onClick={handleCreateApprovisionnement}>Créer l'Approvisionnement</button>
              <button className="boncomclient-btn boncomclient-btn-grey" onClick={() => { setShowApproModal(false); setApproClientId(null); setApproClientNom(''); setApproAdresseLivId(null); setApproNewLines([]); }}>Annuler</button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════ */}
      {/* 🟢 MODAL QUOTA (Avec DEBUG)                               */}
      {/* ══════════════════════════════════════════════════════════ */}
              <AchatQuotaModal
        isOpen={quotaModalOpen}
        onClose={() => { 
          setQuotaModalOpen(false); 
          setSelectedLine(null); 
          clearMassSelection(); 
          setQuotaChannel('EMAIL');
          
        }}
        line={selectedLine}
        lines={massQuotaLines.length > 0 ? massQuotaLines : []}
        fournisseurs={fournisseurs}
        channel={quotaChannel} // 🟢 On passe le canal à la modale
        
        onSend={async (data) => {
          try {
            const payload = {
              channel: quotaChannel, // 🟢 On ajoute le canal au payload ('EMAIL' ou 'WHATSAPP')
              fournisseurIds: [Number(data.fournisseurId)],
              message: data.message || "",
              lines: (data.lines || []).map(l => ({
                reference: l.reference || 'N/A',
                refFabricant: l.refFabricant || 'N/A',
                ean: l.ean || 'N/A',
                quantity: Number(l.quantity) || 0
              }))
            };

            console.log("🟢 Payload envoyé au backend :", payload);

            await achatService.sendMassQuota(payload);
            
            alert(`Demande de quota envoyée par ${quotaChannel === 'WHATSAPP' ? 'WhatsApp' : 'Email'} avec succès !`);
            setQuotaModalOpen(false);
            
            if (massQuotaLines.length > 0) {
              clearMassSelection();
            } else {
              setSelectedLine(null);
            }
            
            fetchAppro();
            fetchToutes();
            fetchAacheterref();
            
          } catch (err) {
            console.error("🔴 Erreur lors de l'envoi du quota :", err);
            alert("Erreur : " + err.message);
          }
        }}
      />
       
    </div>
  );
}